module.exports = __webpack_public_path__ + "img/ico-plus-light.9a300f4c.svg";